webpackJsonp([0],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var platform_browser_dynamic_1 = __webpack_require__(1);
	var core_1 = __webpack_require__(3);
	var app_module_1 = __webpack_require__(23);
	if (true) {
	    core_1.enableProdMode();
	}
	platform_browser_dynamic_1.platformBrowserDynamic().bootstrapModule(app_module_1.AppModule);


/***/ },

/***/ 23:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var platform_browser_1 = __webpack_require__(21);
	var angular2_jwt_1 = __webpack_require__(24);
	var ng2_cookies_1 = __webpack_require__(36);
	var app_routing_module_1 = __webpack_require__(39);
	var app_component_1 = __webpack_require__(622);
	var auth_module_1 = __webpack_require__(624);
	var AppModule = (function () {
	    function AppModule() {
	    }
	    AppModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                platform_browser_1.BrowserModule,
	                app_routing_module_1.AppRoutingModule,
	                auth_module_1.AuthModule
	            ],
	            declarations: [
	                app_component_1.AppComponent
	            ],
	            providers: [
	                angular2_jwt_1.provideAuth({
	                    headerName: "Authorization",
	                    headerPrefix: "Bearer",
	                    tokenName: "id_token",
	                    tokenGetter: (function () { return ng2_cookies_1.Cookie.get("id_token"); }),
	                    globalHeaders: [{ 'Content-Type': 'application/json' }],
	                    noJwtError: true,
	                    noTokenScheme: true
	                })
	            ],
	            bootstrap: [app_component_1.AppComponent]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], AppModule);
	    return AppModule;
	}());
	exports.AppModule = AppModule;


/***/ },

/***/ 39:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(40);
	var logged_in_guard_1 = __webpack_require__(64);
	var login_component_1 = __webpack_require__(66);
	var AppRoutingModule = (function () {
	    function AppRoutingModule() {
	    }
	    AppRoutingModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                router_1.RouterModule.forRoot([
	                    { path: 'login', component: login_component_1.LoginComponent },
	                    { path: '', redirectTo: 'home', pathMatch: 'full' },
	                    {
	                        path: '',
	                        loadChildren: function () { return new Promise(function (resolve) { __webpack_require__.e/* nsure */(1, function (require) { resolve(__webpack_require__(68)['HomeModule']); }); }); },
	                        canActivate: [logged_in_guard_1.LoggedInGuard]
	                    }
	                ])
	            ],
	            exports: [
	                router_1.RouterModule
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], AppRoutingModule);
	    return AppRoutingModule;
	}());
	exports.AppRoutingModule = AppRoutingModule;


/***/ },

/***/ 64:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(40);
	var auth_service_1 = __webpack_require__(65);
	var LoggedInGuard = (function () {
	    function LoggedInGuard(user, router) {
	        this.user = user;
	        this.router = router;
	    }
	    LoggedInGuard.prototype.canActivateChild = function (route, state) {
	        return this.canActivate(route, state);
	    };
	    LoggedInGuard.prototype.canActivate = function (route, state) {
	        if (this.user.isLoggedIn()) {
	            return true;
	        }
	        this.user.redirectUrl = state.url;
	        this.router.navigate(['/login']);
	        return false;
	    };
	    LoggedInGuard = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object])
	    ], LoggedInGuard);
	    return LoggedInGuard;
	    var _a, _b;
	}());
	exports.LoggedInGuard = LoggedInGuard;


/***/ },

/***/ 65:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(40);
	var angular2_jwt_1 = __webpack_require__(24);
	var ng2_cookies_1 = __webpack_require__(36);
	var AuthService = (function () {
	    function AuthService(router) {
	        this.router = router;
	        // Configure Auth0
	        this.redirectUrl = '';
	        this.auth0 = new Auth0({
	            domain: 'rockalltech.auth0.com',
	            clientID: '9oCqpcavKKmmfTV0nDUHSdNMCao9v9cr',
	            responseType: 'token',
	            callbackURL: window.location.protocol + '//' + window.location.host
	        });
	        this.loggedIn = false;
	        var result = this.auth0.parseHash(window.location.hash);
	        if (result && result.idToken) {
	            ng2_cookies_1.Cookie.set('id_token', result.idToken);
	            ng2_cookies_1.Cookie.set('current_user', result.idTokenPayload.username);
	        }
	        else if (result && result.error) {
	        }
	    }
	    AuthService.prototype.login = function (username, password, callback) {
	        this.auth0.login({
	            connection: 'Username-Password-Authentication',
	            responseType: 'token',
	            username: username,
	            password: password,
	            state: this.redirectUrl,
	            scope: 'openid username'
	        }, function (err) {
	            if (err) {
	                return callback(err);
	            }
	        });
	    };
	    ;
	    AuthService.prototype.isLoggedIn = function () {
	        if (angular2_jwt_1.tokenNotExpired(null, ng2_cookies_1.Cookie.get('id_token'))) {
	            return true;
	        }
	        this.logout();
	        return false;
	    };
	    ;
	    AuthService.prototype.logout = function () {
	        ng2_cookies_1.Cookie.deleteAll();
	    };
	    ;
	    AuthService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _a) || Object])
	    ], AuthService);
	    return AuthService;
	    var _a;
	}());
	exports.AuthService = AuthService;


/***/ },

/***/ 66:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var LoginComponent = (function () {
	    function LoginComponent() {
	    }
	    LoginComponent = __decorate([
	        core_1.Component({
	            selector: "login",
	            template: __webpack_require__(67),
	        }), 
	        __metadata('design:paramtypes', [])
	    ], LoginComponent);
	    return LoginComponent;
	}());
	exports.LoginComponent = LoginComponent;


/***/ },

/***/ 67:
/***/ function(module, exports) {

	module.exports = "<div class=\"login offset-md-4 col-md-4 white-background top-off\">\n\n  <div  style=\"width: 300px; margin: 20px 0;\">\n    <img src=\"/assets/img/fastnet-logo-trans.png\" />\n  </div>\n  <div class=\"eval_form\">\n    <login-form></login-form>\n  </div>\n  <a href=\"http://www.rockalltech.com\"><img src=\"/assets/img/rockall_logo_with_lens_flare.png\" height=\"50px\" /></a>\n</div>\n";

/***/ },

/***/ 148:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var angular2_jwt_1 = __webpack_require__(24);
	var API_ROOT = 'https://app.fastnetbeta.com/';
	var HttpAPIWrapper = (function () {
	    function HttpAPIWrapper(http) {
	        this.http = http;
	        this.apiRoot = API_ROOT;
	    }
	    HttpAPIWrapper.prototype.head = function (url) {
	        return this.http.head("" + this.apiRoot + url);
	    };
	    HttpAPIWrapper.prototype.get = function (url, options) {
	        return this.http.get("" + this.apiRoot + url, options);
	    };
	    HttpAPIWrapper.prototype.post = function (url, options) {
	        return this.http.post("" + this.apiRoot + url, options);
	    };
	    HttpAPIWrapper = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof angular2_jwt_1.AuthHttp !== 'undefined' && angular2_jwt_1.AuthHttp) === 'function' && _a) || Object])
	    ], HttpAPIWrapper);
	    return HttpAPIWrapper;
	    var _a;
	}());
	exports.HttpAPIWrapper = HttpAPIWrapper;


/***/ },

/***/ 622:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var AppComponent = (function () {
	    function AppComponent() {
	    }
	    AppComponent = __decorate([
	        core_1.Component({
	            selector: 'fastnet',
	            template: __webpack_require__(623)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], AppComponent);
	    return AppComponent;
	}());
	exports.AppComponent = AppComponent;


/***/ },

/***/ 623:
/***/ function(module, exports) {

	module.exports = "<router-outlet></router-outlet>\n";

/***/ },

/***/ 624:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var forms_1 = __webpack_require__(73);
	var http_1 = __webpack_require__(25);
	var http_api_wrapper_1 = __webpack_require__(148);
	var auth_service_1 = __webpack_require__(65);
	var logged_in_guard_1 = __webpack_require__(64);
	var login_component_1 = __webpack_require__(66);
	var login_form_component_1 = __webpack_require__(625);
	var AuthModule = (function () {
	    function AuthModule() {
	    }
	    AuthModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                forms_1.FormsModule,
	                http_1.HttpModule
	            ],
	            declarations: [
	                login_component_1.LoginComponent,
	                login_form_component_1.LoginFormComponent
	            ],
	            providers: [
	                auth_service_1.AuthService,
	                http_api_wrapper_1.HttpAPIWrapper,
	                logged_in_guard_1.LoggedInGuard
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], AuthModule);
	    return AuthModule;
	}());
	exports.AuthModule = AuthModule;


/***/ },

/***/ 625:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(40);
	var auth_service_1 = __webpack_require__(65);
	var LoginFormComponent = (function () {
	    function LoginFormComponent(userService, router) {
	        this.userService = userService;
	        this.router = router;
	        this.loginSuccess = true;
	    }
	    LoginFormComponent.prototype.onSubmit = function () {
	        var _this = this;
	        this.userService.login(this.username, this.password, function (err) {
	            _this.loginSuccess = false;
	        });
	    };
	    LoginFormComponent = __decorate([
	        core_1.Component({
	            selector: 'login-form',
	            template: __webpack_require__(626)
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object])
	    ], LoginFormComponent);
	    return LoginFormComponent;
	    var _a, _b;
	}());
	exports.LoginFormComponent = LoginFormComponent;


/***/ },

/***/ 626:
/***/ function(module, exports) {

	module.exports = "<form (ngSubmit)=\"onSubmit()\" #loginForm=\"ngForm\">\n  <div [hidden]=\"loginSuccess\" class=\"alert alert-danger\">\n    You entered incorrect Username/Password.\n  </div>\n  <div class=\"row\">\n    <div class=\"col-md-12\">\n      <div class=\"md-form\">\n        <input [(ngModel)]=\"username\" type=\"text\"\n          class=\"form-control\" id=\"username\"\n          placeholder=\"Enter your username\" name=\"username\">\n        <label for=\"username\" class=\"active\">Username</label>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"row\">\n    <div class=\"col-md-12\">\n      <div class=\"md-form\">\n        <input [(ngModel)]=\"password\" type=\"password\"\n          class=\"form-control\" id=\"password\"\n          placeholder=\"Enter your password\" name=\"password\">\n        <label for=\"password\" class=\"active\">Password</label>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"row\">\n    <div class=\"col-md-12\">\n      <div class=\"md-form\">\n        <button type=\"submit\" id=\"login-btn\" class=\"btn btn-primary\"\n          [disabled]=\"!loginForm.form.valid\">\n          Login\n        </button>\n        <a href=\"#\" class=\"pull-right\" style=\"font-size: 12px; margin-top: 14px\">Forgot your password?</a>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"row\">\n    <div class=\"col-md-12\">\n      <div class=\"md-form\">\n        <p class=\"text-md-center\"></p>\n      </div>\n    </div>\n  </div>\n</form>\n";

/***/ }

});


/** WEBPACK FOOTER **
 ** app.cd39cc2b21e87e487b6c.js
 **/